import {NgModule} from '@angular/core';

import {RouterModule, Routes} from '@angular/router';

import {InicioComponent} from './inicio/inicio.component';
import {InscricaoComponent} from './inscricao/inscricao.component';
import {InscricaoDetailComponent} from './inscricao-detail/inscricao-detail.component';
import {InscricaoEditComponent} from "./inscricao-edit/inscricao-edit.component";
import {EventosComponent} from './eventos/eventos.component';
import {AcessoComponent} from './acesso/acesso.component';
import {CadastroComponent} from './cadastro/cadastro.component';
import {TrabalhoComponent} from './trabalho/trabalho.component';
import {RecuperarSenhaComponent} from './recuperar-senha/recuperar-senha.component';
import {NovaSenhaComponent} from './nova-senha/nova-senha.component';
import {AvaliacaoListComponent} from './avaliacao-list/avaliacao-list.component';
import {AdminComponent} from './admin/admin.component';
import {TrabalhoListComponent} from './trabalho-list/trabalho-list.component';
import {InscricaoListComponent} from "./inscricao-list/inscricao-list.component"
import {TrabalhoDetailComponent} from "./trabalho-detail/trabalho-detail.component"
import {UsuarioDetailComponent} from "./usuario-detail/usuario-detail.component"
import {AvaliacaoDetailComponent} from "./avaliacao-detail/avaliacao-detail.component"
import {UsuarioListComponent} from "./usuario-list/usuario-list.component";
import {PerfilComponent} from "./perfil/perfil.component";
import {PerfilDetailComponent} from "./perfil-detail/perfil-detail.component";
import {PerfilListComponent} from "./perfil-list/perfil-list.component";
import {EventoComponent} from "./evento/evento.component";
import {EventoDetailComponent} from "./evento-detail/evento-detail.component";
import {EventoListComponent} from "./evento-list/evento-list.component";
import {TrabalhoEditComponent} from "./trabalho-edit/trabalho-edit.component";
import {ReportComponent} from "./report/report.component";
import {ReportListComponent} from "./report-list/report-list.component";
import {ReportAccessComponent} from "./report-access/report-access.component";
import {ReportDetailComponent} from "./report-detail/report-detail.component";
import {InscricoesUsuariosListComponent} from "./inscricoes-usuarios-list/inscricoes-usuarios-list.component";
import {ConfigComponent} from "./config/config.component";
import {PedirRecursoComponent} from "./pedir-recurso/pedir-recurso.component";
import {EncaminharRecursoComponent} from "./encaminhar-recurso/encaminhar-recurso.component";
import {AvaliarRecursoListComponent} from "./avaliar-recurso-list/avaliar-recurso-list.component";
import {AvaliarRecursoComponent} from "./avaliar-recurso/avaliar-recurso.component";
import {CertificadoComponent} from "./certificado/certificado.component";
import {PenalidadeComponent} from "./penalidade/penalidade.component";
import {PenalidadeListComponent} from "./penalidade-list/penalidade-list.component";

const routes: Routes = [
    {path: '', redirectTo: '/inicio', pathMatch: 'full'},
    {path: 'acesso', component: AcessoComponent},
    // { path: 'inicio',  component: InicioComponent },
    // { path: 'inicio',  redirectTo: '/acessoacesso', pathMatch: 'full' },
    {path: 'inicio', component: InicioComponent},
    {path: 'eventos', component: EventosComponent},
    {path: 'report', component: ReportComponent},
    {path: 'report-list', component: ReportListComponent},
	{path: 'report-detail/:id', component: ReportDetailComponent},
	{path: 'report-access', component: ReportAccessComponent},
    {path: 'report-access/:index', component: ReportAccessComponent},
    {path: 'inscricao-list', component: InscricaoListComponent},
    {path: 'inscricao-detail/:id', component: InscricaoDetailComponent},
	{path: 'inscricao-edit/:id', component: InscricaoEditComponent},
	{path: 'inscricao/:id', component: InscricaoComponent},
    {path: 'cadastro', component: CadastroComponent},
    {path: 'trabalho/:id', component: TrabalhoComponent},
    {path: 'trabalho-detail/:id', component: TrabalhoDetailComponent},
    {path: 'trabalho-edit/:id', component: TrabalhoEditComponent},
    {path: 'recuperar-senha', component: RecuperarSenhaComponent},
    {path: 'senha/nova/:hash', component: NovaSenhaComponent},
    {path: 'avaliacao', component: AvaliacaoListComponent},
    {path: 'avaliacao-detail/:id_t/:ver', component: AvaliacaoDetailComponent},
    {path: 'avaliacao-detail/:id_t', component: AvaliacaoDetailComponent},
    {path: 'admin', component: AdminComponent},
    {path: 'trabalho-list', component: TrabalhoListComponent},
    {path: 'usuario-detail/:id', component: UsuarioDetailComponent},
    {path: 'usuario-list', component: UsuarioListComponent},
    {path: 'perfil', component: PerfilComponent},
    {path: 'perfil-detail/:id', component: PerfilDetailComponent},
    {path: 'perfil-list', component: PerfilListComponent},
    {path: 'evento', component: EventoComponent},
    {path: 'evento-detail/:id', component: EventoDetailComponent},
    {path: 'evento-list', component: EventoListComponent},
	{path: 'inscricoes-usuarios-list', component: InscricoesUsuariosListComponent},
	{path: 'config', component: ConfigComponent},
	{path: 'pedir-recurso/:id_t', component: PedirRecursoComponent},
	{path: 'encaminhar-recurso', component: EncaminharRecursoComponent},
	{path: 'avaliar-recurso-list', component: AvaliarRecursoListComponent},
	{path: 'avaliar-recurso/:id_t', component: AvaliarRecursoComponent},
	{path: 'certificado', component: CertificadoComponent},
	{path: 'penalidade-list', component: PenalidadeListComponent},
	{path: 'penalidade', component: PenalidadeComponent},
	{path: 'penalidade/:id', component: PenalidadeComponent},
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts